import {store} from '../store';


export const getImprovementById = (id) => {
    const state = store.getState()
    let improvements = state.indicativeOptionData?.improvements || [];
    return improvements.find(d => d.id === id) || {}
}

export const getProjectAmountFromProjectImprovements = (improvements = []) => improvements.reduce((r,d) => +d.value + r, 0)
